/**
 * Maps holidays to visual themes so each culture/holiday can use a distinct style.
 */
export var getHolidayThemeKey = function (holiday) {
    if (!holiday) {
        return 'seasonal';
    }
    switch (holiday.id) {
        case 'lunar-new-year':
            return 'lunar';
        case 'ramadan':
            return 'ramadan';
        case 'eid-al-fitr':
        case 'eid-al-adha':
            return 'eid';
        case 'diwali':
        case 'holi':
            return 'hindu';
        case 'rosh-hashanah':
        case 'yom-kippur':
        case 'hanukkah':
        case 'passover':
            return 'jewish';
        case 'thanksgiving':
            return 'harvest';
        case 'new-year':
            return 'newyear';
        case 'christmas':
        case 'christmas-season':
        case 'advent':
        case 'easter':
            return 'christian';
        default:
            break;
    }
    switch (holiday.culture) {
        case 'christian':
            return 'christian';
        case 'islamic':
            return 'ramadan';
        case 'jewish':
            return 'jewish';
        case 'hindu':
            return 'hindu';
        case 'cultural':
            return 'seasonal';
        case 'secular':
            return holiday.id === 'thanksgiving' ? 'harvest' : 'newyear';
        default:
            return 'seasonal';
    }
};
export var getHolidayThemeClassName = function (baseClass, holiday) { return "".concat(baseClass, "--").concat(getHolidayThemeKey(holiday)); };
